import { Injectable } from '@angular/core';
import { Requests } from '../content-desktop/constants/URLRequests';
import { Observable, Subject } from 'rxjs';
import { IVehicleGroupsWithBodyType } from '../../interfaces/IVehicleGroupsWithBodyTypes';
import { IObjectType } from '../../interfaces/IObjectType';
import {UsageType} from '../../../../common/interfaces/cre/usage-type';
import {HttpService} from '../../../../common/services/http.service';

@Injectable({
  providedIn: 'root',
})
export class DataCategoryService {
  statusOpenedSubject = new Subject<boolean>();
  statusOpened$ = this.statusOpenedSubject.asObservable();

  constructor(private _http: HttpService) {}

  setNewStatus(status: boolean) {
    this.statusOpenedSubject.next(status);
  }

  getVehicleGroupsWithBodyTypes(): Observable<IVehicleGroupsWithBodyType[]> {
    return this._http.request(Requests['getVehicleGroupsWithBodyTypes']);
  }

  getUsageTypes(): Observable<UsageType[]> {
    return this._http.request(Requests['getUsageTypes']);
  }

  getObjectTypes(): Observable<IObjectType[]> {
    return this._http.request(Requests['getObjectTypes']);
  }
}
